import React from 'react';
import Image, { ImageProps } from 'react-bootstrap/Image';
import { ImageModel } from '../../models/globals';

// Any ImageProps we explicitly override should generally be omitted
type RemainingImageProps = Omit<ImageProps, 'alt' | 'onError' | 'src'>;

interface PictureProps extends ImageModel, RemainingImageProps {
    defaultImage?: ImageModel | null;
    omitAlt?: boolean;
}

const Picture: React.FC<PictureProps> = ({ altText, url, webpUrl, defaultImage, omitAlt, ...imgProps }) => {
    const [workingImage, setWorkingImage] = React.useState<ImageModel>();

    React.useEffect(() => {
        // Defer setting sources until we are in the browser to mitigate
        // a race condition where the onError handler can miss a 404
        setWorkingImage({
            altText,
            url,
            webpUrl,
        });
    }, []);

    return (
        <picture>
            <source
                data-testid={workingImage && `${workingImage.altText}-webp-source`}
                srcSet={workingImage?.webpUrl}
                type="image/webp"
            />
            <Image
                alt={omitAlt ? '' : workingImage?.altText}
                aria-label={omitAlt ? workingImage?.altText : undefined}
                src={workingImage?.url}
                onError={() => {
                    if (defaultImage) {
                        setWorkingImage(defaultImage);
                    }
                }}
                {...imgProps}
            />
        </picture>
    );
};

export { Picture, PictureProps };
